module.exports = __webpack_public_path__ + "static/media/bbqube.95988a8f.svg";